import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { FormCombobox } from '../../CoForm'
import { getCarriersRequest } from 'store/modules/comuns/carriers/reducer'

export function ComboboxCarriers(props) {
  const dispatch = useDispatch()

  const carriers = useSelector((state) => state.comuns.carriers.carriers)
  const loading = useSelector((state) => state.comuns.carriers.loading)

  const carriersOptions = useMemo(() => {
    return carriers.map((carrier) => ({
      value: carrier.cod_empresa,
      label: carrier.wee_razao_social,
    }))
  }, [carriers])

  useEffect(() => {
    dispatch(getCarriersRequest())
  }, [])

  return (
    <FormCombobox
      options={carriersOptions}
      loading={loading}
      loadingText="Buscando transportadoras..."
      noOptionsText="Nenhuma transportadora encontrada"
      {...props}
    />
  )
}
